import React from 'react';
import css from './index.css';
import {useTranslation} from 'react-i18next';

export default function Education() {

const {t,i18n}=useTranslation();

  return (
   
    <section className="education">
    <div>
    <h1 className="title">2014/2015</h1>
    <br/>
    <h2 className="subtitle">{t('educationsubtitile1.label')} <br/>Lycee bab sahara</h2>
    <br/>
   <p className="textcontent">{t('educationtextcontent1.label')}<br/>
   Guelmim</p>
    </div>
    <div>
    <h1 className="title">2015/2017</h1>
    <br/>
    <h2 className="subtitle">{t('universityname.label')}<br/>{t('educationsubtitile1.labe2')}</h2>
    <br/>
   <p className="textcontent"> Agadir</p>
    </div>
    <div>
    <h1 className="title"> 2017/2019</h1>
    <br/>
    <h2 className="subtitle">{t('ofpptname.label')}<br/>{t('computerscience.label')}</h2>
     <br/>
     <p className="textcontent">Agadir - Guelmim </p>
    </div>
    </section>
  );
}
